<template>
    <div class="col-lg-8">
        <div class="profile-block">
            <h3 class="profile-block-heading w-auto">
                {{ lang.favoriteOffersList }}
            </h3>
            <span class="offers-remove" @click="clearAllFavorites">{{ lang.removeButton }}</span>
        </div>

        <template v-if="this.favoritesUpdated.length > 0  && isClear === false">
            <p class="profile-block-info">{{ lang.favoriteOffersInfo }}</p>
        </template>

        <div class="fav-offers-panel" v-model="isClear">
            <div class="profile-block">

                <template v-if="this.favoritesUpdated.length && isClear === false">

                    <div class="offer-item"
                         v-for="offer in favoritesUpdated"
                         :key="offer.property_id">
                        <template v-if="offer.property">

                        <div class="offer-image-panel">
                               <span class="checkbox-star-panel"
                                     data-toggle="tooltip"
                                     :data-original-title="lang.favoriteOffers">
                                    <label class="checkbox-star"

                                           @click="updateFavorites(offer.property_id)">

                                        <input type="checkbox" name="favorites" :checked="true" disabled>
                                        <span class="checkmark"></span>
                                    </label>
                               </span>
                               <a :href="offer.property ? prefixEn + '/properties/'+offer.property.slug : '#'" :title="offer.property.title ? offer.property.title : ''" class="offer-favorite-image">
                                   <div class="offer-image zoom" :style="{ 'background-image': 'url(' + (offer.property.first_media_url ? offer.property.first_media_url : '/assets/images/placeholders/placeholder-small.jpg') + ')' }"></div>
                               </a>
                        </div>

                        <div class="offer-info">
                            <div class="offer-title">
                                {{ offer.property.title ? offer.property.title : '' }}
                            </div>
                            <div class="offer-location ellipsis large">
                                {{ offer.property.address ? offer.property.address : '' }}
                            </div>
                            <div class="d-flex justify-content-between">
                                <div class="offer-price">
                                    € {{ offer.property.monthly_rent ? offer.property.monthly_rent : '' }}
                                </div>
                                <div class="offer-surface">
                                    {{ offer.property.total_floorage ? offer.property.total_floorage : '' }} {{ lang.sq_m }}
                                </div>
                            </div>

                            <div class="offer-info-label pt-1">
                                <div></div>
                                <a :href="prefixEn + offer.property.slug ? prefixEn + '/properties/'+offer.property.slug : '#'" class="offer-link">{{ lang.see_btn }}</a>
                            </div>
                        </div>
                        </template>
                    </div>
                </template>
                <template v-else>
                        <h4 class="no-offers">{{ lang.no_offers }}</h4>
                </template>
            </div>
        </div>

<!--        Disable Pagination Temporary

        <template v-if="this.favoritesUpdated.length !== 0">
            <paginate
                    :page-count="getPageCount"
                    :page-range="3"
                    :margin-pages="2"
                    :click-handler="clickCallback"
                    :prev-text="''"
                    :next-text="''"
                    :container-class="'pagination'">
            </paginate>
        </template>-->


    </div>
</template>

<script>

    import moment from 'moment';

    const lang = $('body').data().locale;
    const enPrefix = lang === 'en' ? '/en' : '';

    moment.locale(lang);

    export default {
        name: "FavoriteOffers",
        props: {
            userFavorites: '',
            userFavoritesClear: '',

            userIsFavoritesUpdate: '',
            userFavoritesUpdate: '',
        },
        data: function() {
            return {
                /* Get Offers from DB */
                offers: this.userFavorites,
                offersClear: this.userFavoritesClear,

                prefixEn: enPrefix,

                filteredOffers: '',

                isOffersUpdate: this.userIsFavoritesUpdate,

                /* Emitted Value */
                updatedOffers: this.userFavoritesUpdate,

                perPage: 6,
                currentPage: 1,

                //**** Translations *****//
                lang: jsLangs
            }
        },
        computed: {
            /*** Watch if 'Clear All' button is checked ***/
            isClear: function () {
                return this.offersClear;
            },
            isFavoritesUpdate: function () {
                return this.isOffersUpdate;
            },

            favoritesUpdated: function () {
                console.log(this.offers);

                let current = this.currentPage * this.perPage;
                let start = current - this.perPage;

                if (this.isOffersUpdate === true) {
                   // Disable Pagination Temporary
                   // return this.updatedOffers.slice(start, current);

                    return this.updatedOffers

                } else {
                    // Disable Pagination Temporary
                   // return this.offers.slice(start, current);

                    return this.offers;
                }

            },
            getPageCount: function () {
                if (this.isOffersUpdate === true) {

                    return Math.ceil(this.favoritesUpdated.length / this.perPage);

                } else {
                    return Math.ceil(this.offers.length / this.perPage);
                }
            },
        },
        methods: {
            clickCallback: function(pageNum) {
                this.currentPage = Number(pageNum);
            },

            /*** Method - Update Favorites (Remove single item onclick) ***/
            updateFavorites: function(propertyID) {

                /**** Updated Offer List ****/
                this.updatedOffers = this.favoritesUpdated;

                /***** Emit Value ******/
                this.$emit("is-favorites-updated", this.isOffersUpdate = true);

                this.updatedOffers.map((item) => {

                    if (item.property.id === propertyID) {
                        $.ajax({
                            url: `${enPrefix}/properties/${ propertyID }/favorite`,
                            type: 'GET',
                            data: {
                                favorite: false
                            },
                            success: () => {
                                toastr.info(lang.toastrMsg_removedFromFavorites, lang.toastrMsg_removedFromFavoritesTitle);
                                $("[data-toggle='tooltip']").tooltip('dispose');

                                this.updatedOffers.splice(this.updatedOffers.indexOf(item), 1);

                                /* Updated */
                                this.$emit("favorites-updated", this.updatedOffers);
                            },
                            complete: function() { },
                            error: function (err) {
                                console.log(err);
                            }
                        });
                    }
                });
            },

            /*** Method clears all items in the list ***/
            /***** Emit Value ******/
            clearAllFavorites: function() {
                this.offers.map((item) => {

                    $.ajax({
                        url: `${enPrefix}/properties/${ item.property.id }/favorite`,
                        type: 'GET',
                        data: {
                            favorite: false
                        },
                        success: () => {
                            // toastr.info('Обявите са премахнати от "Любими"', 'Премахване на обява');
                            toastr.info(lang.toastrMsg_multipleRemovedFromFavorites, lang.toastrMsg_multipleRemovedFromFavoritesTitle);
                            /** Remove all items form Favorites **/
                            this.offers.splice(item);

                            this.$emit("clear-all", this.offersClear = true);
                        },
                        complete: function() { },
                        error: function (err) {
                            console.log(err);
                        }
                    });

                });
            }
        },
        mounted() {
            $('[data-toggle="tooltip"]').tooltip();
        },
    }
</script>
